import { render, staticRenderFns } from "./Species.vue?vue&type=template&id=a1d2b2a6&scoped=true"
import script from "./Species.vue?vue&type=script&lang=js"
export * from "./Species.vue?vue&type=script&lang=js"
import style0 from "./Species.vue?vue&type=style&index=0&id=a1d2b2a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d2b2a6",
  null
  
)

export default component.exports